import { Component } from '@verndale/core';

class SectionHero extends Component {
  setupDefaults() {
    this.dom = {
      image: this.el.querySelector('.section-hero__image')
    };
    this.setBackground();
  }

  addListeners() {
    if (this.dom.image) {
      this.dom.image.addEventListener('load', ::this.setBackground);
    }
  }

  setBackground() {
    const imageUrl = this.dom.image.currentSrc || this.dom.image.src;
    this.dom.image.style.backgroundImage = `url("${imageUrl}")`;
  }
}

export default SectionHero;
